import * as React from 'react';
import { cn } from '@/lib/utils';
import { VariantProps, cva } from 'class-variance-authority';

const headingVariants = cva('font-semibold tracking-tight', {
  variants: {
    level: {
      1: 'scroll-m-20 text-4xl font-extrabold lg:text-5xl',
      2: 'scroll-m-20 border-b pb-2 text-3xl font-semibold first:mt-0',
      3: 'scroll-m-20 text-2xl font-semibold',
      4: 'scroll-m-20 text-xl font-semibold',
      5: 'scroll-m-20 text-lg font-semibold',
      6: 'scroll-m-20 text-base font-semibold',
    },
  },
  defaultVariants: {
    level: 1,
  },
});

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ className, level = 1, as, children, ...props }, ref) => {
    const Component = as || (`h${level}` as const);

    return (
      <Component
        className={cn(headingVariants({ level, className }))}
        ref={ref}
        {...props}
      >
        {children}
      </Component>
    );
  }
);
Heading.displayName = 'Heading';

export { Heading, headingVariants };
